const CONTAINER_ID = 'payment-container';

const LANGUAGES = ['es', 'en', 'fr', 'it', 'de', 'pt', 'nl', 'pl', 'ca', 'hr', 'he', 'jp', 'ru', 'hu', 'ro'];

const SCRIPT_ID = 'paynopainScript';

const SCRIPT_URL = `${process.env.PROVIDER_PAYNOPAIN_URL}/paylands-checkout-sdk.js`;

export { CONTAINER_ID, LANGUAGES, SCRIPT_ID, SCRIPT_URL };
